import React from 'react';

import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import cardProjetPlacementPng from '@/assets/images/projet_placement.png';
import cardProjetPlacementWebp from '@/assets/images/projet_placement.webp';
import Image from '@/components/Image/Image';
import { URLS } from '@/constants/urls';

import styles from './styles.module.css';

const CardProjectInvestment: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.projectPlacementCard}>
      <div className={styles.projectPlacementCardText}>
        <h2 className={styles.projectPlacementCardTitle}>{t('cardProjectInvestment.title')}</h2>
        <p className={styles.projectPlacementCardDescription}>{t('cardProjectInvestment.description')}</p>
        <MtxButton size="medium" onClick={() => window.open(URLS.MTP_URL, '_blank', 'noopener')}>
          {t('cardProjectInvestment.buttonText')}
        </MtxButton>
      </div>

      <div className={styles.projectPlacementCardImage}>
        <Image defaultSrc={cardProjetPlacementPng} webpSrc={cardProjetPlacementWebp} alt="Projet placement" />
      </div>
    </div>
  );
};

export default CardProjectInvestment;
